import React from 'react';
import { useTranslation } from '../../../hooks/useTranslation';

interface StepperProps {
    activeStep: number;
    steps: string[];
    theme?: 'light' | 'dark'; 
}

const Stepper: React.FC<StepperProps> = ({ activeStep, steps, theme }) => {
    const { t } = useTranslation();
    const translatedSteps = steps.map(step => t(step));

    const isDarkMode = theme === 'dark';

    const activeLabelColor = isDarkMode ? 'text-text-primary' : 'text-white';
    const inactiveLabelColor = isDarkMode ? 'text-text-tertiary' : 'text-text-muted';

    const activeCircleClasses = 'bg-primary text-text-primary shadow-[0_0_15px_rgba(212,223,51,0.3)]'; 
    const inactiveCircleClasses = isDarkMode
        ? 'bg-bg-secondary border border-primary/30 text-text-muted'
        : 'bg-bg-primary/40 border border-primary/20 text-text-muted';

    const inactiveConnectorBg = isDarkMode ? 'bg-primary/40' : 'bg-primary/20';
    const activeConnectorBg = 'bg-primary';

    return (
        <div className="flex justify-center gap-8 mb-6">
            {translatedSteps.map((label, index) => (
                <div key={label} className="flex items-center gap-3">
                    <div className={`w-8 h-8 rounded-full flex items-center justify-center text-sm transition-all duration-300
                        ${activeStep >= index
                            ? activeCircleClasses
                            : inactiveCircleClasses}`}>
                        {index + 1}
                    </div>
                    <span className={`text-sm ${activeStep >= index ? activeLabelColor : inactiveLabelColor}`}>
                        {label}
                    </span>
                    {index < steps.length - 1 && (
                        <div className={`w-8 h-[1px] ${activeStep > index ? activeConnectorBg : inactiveConnectorBg}`} />
                    )}
                </div>
            ))}
        </div>
    );
};

export default Stepper;
